import * as Sentry from '@sentry/react';
import { ENABLE_SENTRY } from '../../../_configuration';

const reportedMessageIds = new Set<string>();
const messageIdOf = (error: string) => error.match(/"([^"]+)"/)?.[1] ?? error;

// IntlProvider's onError. react-intl 3 passes a string and is silent in production, so raw ICU reached the screen
// unnoticed. It raises each failure twice per render, so each message id is reported once per page load.
export const reportIntlError = (error: string): void => {
  const messageId = messageIdOf(error);
  if (reportedMessageIds.has(messageId)) return;
  reportedMessageIds.add(messageId);
  console.error('IntlProvider: a message could not be formatted', error);
  if (ENABLE_SENTRY) Sentry.captureMessage(error);
};
